import store from '../../store'
import find from 'lodash/find'
import {updateMeetingParticipantsRequest} from '../../actions/meetings'

export function updateMeetingParticipants(meetingId,participants,externalParticipants) {	
	store.dispatch(updateMeetingParticipantsRequest(meetingId,participants,externalParticipants))
}

